//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppFeatures from '@/components/AppFeatures.vue';
import AppPricing from '@/components/AppPricing.vue';
import CallToAction from '@/components/elements/CallToAction.vue';
import AppTestimonials from '~/components/blocks/AppTestimonials.vue';

export default {
  layout: 'hero',
  components: { AppFeatures, AppPricing, CallToAction, AppTestimonials },
  head() {
    return {
      title: 'BOMIST: Inventory & BOM Management Software for Hardware Teams',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Streamline your Inventory, BOMs, Procurement & Production Workflows. All-in-one platform for the electronics manufacturing industry. Download free for Windows, Mac and Linux.'
        }
      ]
    };
  },
  computed: {
    showSenjaCarousel() {
      return process.env.SENJA_HERO_CAROUSEL === 'yes';
    }
  }
};
